<template>
  <div class="ui-d-flex">
    <div
      v-if="icon"
      class="icon-wrapper"
    >
      <UiIcon
        v-if="iconMap[icon] && (iconMap[icon].icon || iconMap[icon].iconSubstyle)"
        :color="iconMap[icon].color || '#fff'"
        :name="icon"
        :substyle="iconMap[icon].iconSubstyle"
        :size="16"
        :class="iconMap[icon].icon"
      />
      <img
        v-if="iconMap[icon] && iconMap[icon].img"
        :src="iconMap[icon].img"
        alt=""
      >
      <i
        v-else
        style="font-size: 16px"
        :class="icon"
      />
    </div>
    <div class="item">
      <ElTooltip
        :disabled="!tooltipPlacement"
        :placement="tooltipPlacement"
        :content="text"
      >
        <div class="text">
          <a
            v-if="isSocial"
            :href="getSocialLink(type, text)"
            :target="type === 'email' && '_blank'"
          >
            {{ text }}
          </a>
          <span v-else>{{ text }}</span>
        </div>
      </ElTooltip>
      <div class="label">
        {{ type }}
      </div>
    </div>
  </div>
</template>

<script>
import telegramImg from '@/assets/theme/icon/telegram.svg';
import instagramImg from '@/assets/theme/icon/instagram.svg';
import facebookImg from '@/assets/theme/icon/facebook.svg';
import twitterImg from '@/assets/theme/icon/twitter.svg';
import viberImg from '@/assets/theme/icon/viber.svg';
import whatsappImg from '@/assets/theme/icon/whatsapp.svg';
import msTeamsImg from '@/assets/theme/icon/ms-teams.svg';

export default {
  props: {
    icon: String,
    text: String,
    type: String,
    iconColor: String,
    isSocial: Boolean,
    tooltipPlacement: String,
  },
  data() {
    return {
      iconMap: {
        email: {
          icon: 'fas fa-envelope',
        },
        skype: {
          iconSubstyle: 'fa',
          color: '#4088f7',
        },
        telegram: {
          img: telegramImg,
        },
        instagram: {
          img: instagramImg,
        },
        facebook: {
          img: facebookImg,
        },
        twitter: {
          img: twitterImg,
        },
        viber: {
          img: viberImg,
        },
        whatsapp: {
          img: whatsappImg,
        },
        ms_teams: {
          img: msTeamsImg,
        },
      },
    };
  },
  methods: {
    getSocialLink(type, value) {
      switch (type) {
        case 'telegram':
          return `tg://resolve?domain=${value.replace('@', '')}`;
        case 'skype':
          return `skype:${value.replace('live:.cid.', '')}?chat`;
        case 'email':
          return `mailto:${value}`;
        default:
          return '';
      }
    },
  },
};

</script>

<style lang="scss" scoped>
.item {
  display: flex;
  flex-direction: column;
  margin-left: 12px;
  overflow: hidden;

  .text {
    height: 22px;
    font-size: 14px;
    font-weight: 600;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    line-height: normal;

    a {
      color: inherit;
      text-decoration: none;
    }
  }

  .label {
    font-size: 12px;
    height: 17px;
    line-height: normal;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
.icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  min-width: 40px;
  height: 40px;
  border-radius: 8px;
  background-color: #e7ecf1;
  font-size: 16px;
  color: #303634;
}
</style>
